import * as AxiosMethods from "./AxiosMethods";

export default class InteraktiveGrafik {

    static apiKey ="QXBpSFNMVVdlYg=="
    static apiSecret = null

    static getTemplateById(queryData) {
        return AxiosMethods.get("/api/interaktivegrafik/gettemplatebyid", queryData);
    }
    
    static getAllTemplates() {
        return AxiosMethods.get("/api/interaktivegrafik/getalltemplates", null);
    }

    static setCurrentTemplate(queryData) {
        return AxiosMethods.putWithApiKey("/api/interaktivegrafik/setcurrenttemplate", queryData, InteraktiveGrafik.apiKey, InteraktiveGrafik.apiSecret);
    }

    static getInteraktiveGrafikSettings(queryData) {
        return AxiosMethods.post("/api/interaktivegrafik/getinteraktivegrafiksettings", queryData);
    }
    static setCurrentDept(queryData) {
        return AxiosMethods.putWithApiKey("/api/interaktivegrafik/setcurrentdept", queryData, InteraktiveGrafik.apiKey, InteraktiveGrafik.apiSecret);
    }
    static setInitialOfferType(queryData) {
        return AxiosMethods.putWithApiKey("/api/interaktivegrafik/setinitialoffertype", queryData, InteraktiveGrafik.apiKey, InteraktiveGrafik.apiSecret);
    }    
    static getSpecialistTopics(queryData) {
        return AxiosMethods.post("/api/interaktivegrafik/getspecialisttopics", queryData);
    }

    static getSpecialistTopicById(queryData) {
        return AxiosMethods.post("/api/interaktivegrafik/getspecialisttopicbyid", queryData);
    }
    
    static getSpecialistTopicImages(queryData) {
        return AxiosMethods.get("/api/interaktivegrafik/getspecialisttopicimages", queryData);
    }

    static addSpecialistTopic(queryData) {
        return AxiosMethods.postWithApiKey("/api/interaktivegrafik/addspecialisttopic", queryData, InteraktiveGrafik.apiKey, InteraktiveGrafik.apiSecret);
    }

    static updateSpecialistTopic(queryData) {
        return AxiosMethods.patchWithApiKey("/api/interaktivegrafik/updatespecialisttopic", queryData, InteraktiveGrafik.apiKey, InteraktiveGrafik.apiSecret);
    }

    static deleteSpecialistTopic(queryData) {
        return AxiosMethods.delWithApiKey("/api/interaktivegrafik/deletespecialisttopic", queryData, InteraktiveGrafik.apiKey, InteraktiveGrafik.apiSecret);
    }

    static getOfferTypeById(queryData) {
        return AxiosMethods.get("/api/interaktivegrafik/getoffertypebyid", queryData);
    }

    static getAllOfferTypes(queryData) {
        return AxiosMethods.get("/api/interaktivegrafik/getalloffertypes", queryData);
    }

    static getLineTypeById(queryData) {
        return AxiosMethods.get("/api/interaktivegrafik/getlinetypebyid", queryData);
    }

    static getAllLineTypes(queryData) {
        return AxiosMethods.get("/api/interaktivegrafik/getalllinetypes", queryData);
    }

    static getOffersByTopic(queryData) {
        return AxiosMethods.post("/api/interaktivegrafik/getoffersbytopic", queryData);
    }

    static addOfferToTopic(queryData) {
        return AxiosMethods.postWithApiKey("/api/interaktivegrafik/addoffertotopic", queryData, InteraktiveGrafik.apiKey, InteraktiveGrafik.apiSecret);
    }

    static updateOffer(queryData) {
        return AxiosMethods.patchWithApiKey("/api/interaktivegrafik/updateoffer", queryData, InteraktiveGrafik.apiKey, InteraktiveGrafik.apiSecret);
    }
    static deleteOffer(queryData) {
        return AxiosMethods.delWithApiKey("/api/interaktivegrafik/deleteoffer", queryData, InteraktiveGrafik.apiKey, InteraktiveGrafik.apiSecret);
    }
}
